<script>
import Layout from "../layouts/main";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { sliceLongString } from "@/utils/mixins/sliceLongString";
import userService from "../../services/userService";
import CustomStore from "devextreme/data/custom_store";
import 'devextreme/data/odata/store';
import moment from "moment";
const dataGridRefKey = "my-data-grid";

export default {
  mixins: [sliceLongString],
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "Dashboard",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      form: {
        email: null,
        password: null,
        confirmPassword: null
      },
      loading: false,
      title: "",
      isAdmin: false,
      user: null,
      editData: false,
      systemUser: null,
      qr: null,
      entities: [],
      usersInvitations: [],
      allowedOperations: ["contains"],
      normalEntities: [],
      dataSource: new CustomStore({
        key: ["id"],
        load: () => {
          return userService.getUserVisits(this.user.id);
        },
      }),
      pageSizes: [5 , 10 ],
      dataGridRefKey,
    };
  },

  computed: {
    ...mapGetters("user", [
      "getUserData", "getLoading", "getSearchUser"
    ]),
    dataGrid: function() {
      return this.$refs[dataGridRefKey].instance;
    }
  },
  methods: {
    ...mapActions("user", ["getUserIpAction", "fetchUserVisits", "getUserByEmailOrPhone", "clearSearchUser", "resetUserPassword"]),
    ...mapActions("modal", ["setData"]),
    ...mapActions("entity", ["checkEntityStatus"]),
    ...mapActions("authfack", ["resetUsername"]),

    setUserData(data) {
      this.setData(data);
    },
    onSubmitCheck() {
      if(this.form.email == null) {
        this.$toast.error('Please enter email or phone');
      } else {
        this.getUserByEmailOrPhone(this.form.email);
      }
    },
    onSubmitReset() {
      if(this.form.password == null || this.form.confirmPassword == null || this.form.password !== this.form.confirmPassword ||
          this.form.password.length < 6) {
        this.$toast.error('Please make sure password and confirm password are identical and password length is at least 6 characters');
      } else {
        let payload = [];
        payload.id = this.getSearchUser.id;
        payload.password = this.form.password;
        this.resetUserPassword(payload);
      }
    }
  },
  beforeCreate() {
    if (this.$store.getters["auth/loggedIn"]) {
      this.$router.replace("/logout");
    }
  },
  beforeMount() {
    if (this.getUserData.email === "lt_techteam@visipoint.com") {
      this.isAdmin = true;
    }
    else {
      this.isAdmin = false;
      this.$router.replace('/');
    }
    this.form.email = null;
    this.form.password = null;
    this.form.confirmPassword = null;
    this.clearSearchUser();
    const { getUserData } = this;
    this.user = getUserData;
    this.userTimezone = moment.tz.guess();
    this.resetUsername();
    if (getUserData.image !== null) {
      this.imageToDisplay = `${process.env.VUE_APP_S3_URL}/${this.getUserData.image}`;
    }
    if (this.getUserData.email === "lt_techteam@visipoint.com") {
      this.isAdmin = true;
    }
    else {
      this.isAdmin = false;
      this.$router.replace('/');
    }
  },
  mounted() {
    this.$store.watch(
        function (state) {
          return state.user;
        },
        function (data) {
          if (data && data.newImage !== null) {
            this.imageToDisplay = `${process.env.VUE_APP_S3_URL}/${data.newImage}`;
          }
        }.bind(this),
        {
          deep: true, //add this if u need to watch object properties change etc.
        }
    );
  },
};
</script>

<template>
  <Layout v-if="this.isAdmin">

    <p class="mobile-view-title">Passport Account</p>

    <!-- system user view  -->
    <section class="dashboard-wrapper">
        <div
            :class="
            this.isAdmin
              ? 'w-100 companies-card-admin companies-card details-card'
              : 'companies-card details-card'
          "
        >
          <div class="input-wrapper email w-100">
            <div
                class="form-group m-d-gruop"
            >
              <b-form-input
                  id="email"
                  name="email"
                  type="email"
                  v-model="form.email"
                  required
              />
              <label for="phone">Email address or phone</label>
            </div>
          </div>

          <div class="action-btns">
            <button
                class="submit-btn btn btn-primary"
                size="md"
                @click="onSubmitCheck"
                :disabled="this.getLoading"
            >
              <i
                  v-if="this.getLoading"
                  class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
              ></i>
              <span v-else>Check</span>
            </button>
          </div>

          <div id="searchUserData" v-if="this.getSearchUser !== null">
            ID: {{this.getSearchUser.id}} <br>
            Email: {{this.getSearchUser.email}} <br>
            Phone: {{this.getSearchUser.phone}} <br>
            First name: {{this.getSearchUser.first_name}} <br>
            Last name: {{this.getSearchUser.last_name}} <br>
            <hr>

            <div class="input-wrapper email w-100">
              <div
                  class="form-group m-d-gruop"
              >
                <b-form-input
                    id="password"
                    name="password"
                    type="password"
                    v-model="form.password"
                    required
                />
                <label for="password">Reset Password</label>
              </div>
            </div>

            <div class="input-wrapper email w-100">
              <div
                  class="form-group m-d-gruop"
              >
                <b-form-input
                    id="confirmPassword"
                    name="confirmPassword"
                    type="password"
                    v-model="form.confirmPassword"
                    required
                />
                <label for="password">Confirm Password</label>
              </div>
            </div>

            <div class="action-btns">
              <button
                  class="submit-btn btn btn-primary"
                  size="md"
                  @click="onSubmitReset"
                  :disabled="this.getLoading"
              >
                <i
                    v-if="this.getLoading"
                    class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
                ></i>
                <span v-else>Reset</span>
              </button>
            </div>
          </div>
        </div>
    </section>
  </Layout>
</template>

<style lang="scss">
.dx-pager .dx-page-sizes .dx-selection, .dx-pager .dx-pages .dx-selection {
  font-weight: 500;
  background-color: #103F5E;
  color: #fff;
}

dx-button-mode-text.dx-button-default {
  background-color: transparent;
  color: #103f5e;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.dx-checkbox-checked .dx-checkbox-icon {
  color: #fff;
  background-color: #103f5e;
  border: none;
  font: 16px/1em DXIcons;
  text-align: center;
}
.dx-checkbox-indeterminate .dx-checkbox-icon {
  background-color: #103f5e;
  color: #fff;
  border: none;
  font: 20px/1em DXIcons;
  text-align: center;
}

.tooltip .tooltip-inner {
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.161);
  color:#787878;
  width: 137px;
}
.tooltip .arrow {
  display: none !important;
}

.dx-placeholder {
  font-family: 'Lato';
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #939393;
}
.dx-master-detail-cell{
  background-color: #F3F3F3 !important;
}
.dx-button-mode-text.dx-button-default{
  background-color: transparent;
  color: #103F5E;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.dx-datagrid-filter-row {
  background-color: #fff !important;
}
</style>
<style lang="scss" scoped>
.mobile-view-title {
  display: none;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #000000;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    display: block;
  }
}
.dashboard-wrapper {
  background: #f3f3f3;
  .dashboard-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    // non system user
    .non-system-user-card {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      .settings {
        display: flex;
        align-items: center;
        width: 80.5%;
        .dropdown {
          margin-right: 36px;
          .dropdown-icon {
            color: #787878;
            font-size: 1.6rem;
          }
          .dropdown-text {
            text-align: center;
            font-size: 16px;
            .deactive {
              color: #f46a6a;
              margin: 0;
              padding: 0;
              font-weight: normal;
            }
          }
        }
        .img {
          display: flex;
          flex-direction: column;
          margin-right: 78px;
          .user-avatar {
            width: 106px;
            height: 106px;
            margin-bottom: 20px;
          }
          .no-edit-mode {
            cursor: context-menu;
          }
        }
        .user-info {
          display: flex;
          justify-content: space-between;
          margin-right: 124px;
          width: 40%;
          .label {
            color: #c7c7c7;
            font-size: 14px;
            margin-bottom: 7px;
            font-weight: 600;
          }
          .card-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .value {
              font-size: 16px;
              color: #495057;
              margin-inline: 0;
              font-weight: normal;
              margin-bottom: 0;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              max-width: 15em;
            }
            .icon {
              color: #787878;
              font-size: 1.4rem;
              font-weight: bold;
              cursor: pointer;
            }
          }
          .user-name,
          .phone {
            padding-right: 60px;
          }
          .user-name,
          .company-name {
            margin-bottom: 37px;
          }
          .company-email-wrapper {
            position: relative;
            padding-left: 37px;
            &::before {
              content: "";
              width: 0;
              height: 100px;
              position: absolute;
              opacity: 0.08;
              border: 0.5px solid #000000;
              background-color: #000;
              top: 25px;
              left: 0;
            }
          }
        }
        .btn-wrapper {
          width: 111.7px;
          .btn {
            width: 100%;
            border-radius: 16.6275px;
            height: 33.26px;
          }
        }
      }
      .qr-wrapper {
        display: flex;
        justify-content: center;
        width: 18%;
        .qr {
          background-color: #f3f3f3;
          padding: 15px 30px;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          text-align: center;
          .qr-title {
            color: #c7c7c7;
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .qr-code {
            margin: 0 auto;
            margin-bottom: 10px;
            border-radius: 12px;
            width: 100%;
          }
          .download-text {
            color: #000;
            text-align: center;
            font-weight: bold;
            font-size: 14px;
            text-align: center;
          }
        }
      }
      .mobile-actions {
        display: none;
      }
    }
    // user
    .user-card {
      .settings {
        display: flex;
        align-items: flex-start;
        .qr-img-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          .img {
            display: flex;
            flex-direction: column;
            margin: 0 auto;
            .user-avatar {
              width: 106px;
              height: 106px;
              margin-bottom: 20px;
            }
            .no-edit-mode {
              cursor: context-menu;
            }
            .btn {
              padding: 0;
              border-radius: 16.6275px;
              height: 33.26px;
            }
          }
          .qr {
            background-color: #f3f3f3;
            padding: 15px 30px;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            text-align: center;
            .qr-title {
              color: #c7c7c7;
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .qr-code {
              margin: 0 auto;
              margin-bottom: 10px;
            }
            .download-text {
              color: #000;
              text-align: center;
              font-weight: bold;
              font-size: 14px;
              text-align: center;
            }
          }
        }
        .dropdown-icon {
          color: #787878;
          font-size: 1.6rem;
        }
        .dropdown-text {
          text-align: center;
          font-size: 16px;
          .deactive {
            color: #f46a6a;
            margin: 0;
            padding: 0;
            font-weight: normal;
          }
        }
      }
      .h-line {
        margin-top: 1.8rem;
        opacity: 0.08;
        border-top: 1px solid #000000;
      }
      .info {
        display: flex;
        justify-content: space-between;
        padding-left: 30px;
        .label {
          color: #c7c7c7;
          font-size: 14px;
          margin-bottom: 7px;
          font-weight: 600;
        }
        .card-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .value {
            font-size: 16px;
            color: #495057;
            margin-inline: 0;
            font-weight: normal;
            margin-bottom: 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 15em;
          }
          .icon {
            color: #787878;
            font-size: 1.4rem;
            font-weight: bold;
            cursor: pointer;
          }
        }
        .user-name,
        .phone {
          padding-right: 50px;
        }
        .user-name,
        .company-name {
          margin-bottom: 37px;
        }
        .company-email-wrapper {
          position: relative;
          padding-left: 37px;
          &::before {
            content: "";
            width: 0;
            height: 100px;
            position: absolute;
            opacity: 0.08;
            border: 0.5px solid #000000;
            background-color: #000;
            top: 25px;
            left: 0;
          }
        }
      }
    }
    // company
    .companies-card {
      height: 454px;
      overflow-y: scroll;
      .header,
      .title-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .header {
        padding-left: 13px;
        margin-bottom: 18px;
        .title {
          margin-bottom: 0;
          font-size: 16px;
          color: #495057;
          font-weight: normal;
          margin-right: 14px;
        }
        .add-icon {
          color: #103f5e;
          font-size: 1.9rem;
          cursor: pointer;
        }
        .search-wrapper {
          input {
            background-color: #f2f2f2;
            padding-left: 55px;
          }
          .search-icon {
            left: 26px;
            top: 1px;
          }
        }
      }
      .sub-title {
        margin-bottom: 16px;
        color: #c7c7c7;
        font-size: 14px;
        font-weight: 500;
        padding-left: 13px;
      }
      .entities-list {
        .entities-line {
          margin: 24px 0;
        }
        .entity-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #f7f7f7;
          padding: 20px;
          margin-left: -3px;
          border-radius: 5px;
          margin-bottom: 15px;
          .entity {
            margin-bottom: 0;
            font-size: 16px;
            font-weight: 600;
            line-height: 19px;
            color: #495057;
          }
          .actions {
            display: flex;
            .accept {
              margin-right: 17px;
            }
            .reject {
              background-color: transparent;
              &:hover {
                background-color: #f46a6a;
              }
            }
            .accept,
            .reject {
              width: 68px;
              font-size: 16px;
            }
            .go-icon {
              font-size: 1.7rem;
              color: #495057;
            }
          }
        }
      }
      .no-data-text {
        font-size: 16px;
        text-align: center;
        margin-top: 50px;
        color: #939393;
      }
    }
    // company admin
    .companies-card-admin {
      .header,
      .title-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .header {
        padding-left: 13px;
        margin-bottom: 18px;
        .title {
          margin-bottom: 0;
          font-size: 16px;
          color: #495057;
          font-weight: normal;
          margin-right: 14px;
        }
        .add-icon {
          color: #103f5e;
          font-size: 1.9rem;
          cursor: pointer;
        }
        .search-wrapper {
          input {
            background-color: #f2f2f2;
            padding-left: 55px;
          }
          .search-icon {
            left: 26px;
            top: 1px;
          }
        }
      }
      .sub-title {
        margin-bottom: 16px;
        color: #c7c7c7;
        font-size: 14px;
        font-weight: 500;
        padding-left: 13px;
      }
      .entities-list {
        .entity-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #f7f7f7;
          padding: 20px;
          margin-left: -3px;
          border-radius: 5px;
          margin-bottom: 15px;
          .entity {
            margin-bottom: 0;
            white-space: nowrap;
          }
          .entity-width {
            width: 150px;
          }
          .actions {
            .accept {
              margin-right: 17px;
            }
            .reject {
              background-color: transparent;
              &:hover {
                background-color: #f46a6a;
              }
            }
            .accept,
            .reject {
              width: 68px;
              font-size: 16px;
            }
            .go-icon {
              font-size: 1.7rem;
              color: #495057;
            }
          }
        }
      }
    }
  }
  .qr-mobile-view {
    width: 100%;
    margin-bottom: 16px;
    display: none;
    .qr {
      background-color: #f3f3f3;
      padding: 15px 30px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      width: 50%;
      margin: 0 auto;
      .qr-title {
        color: #c7c7c7;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .qr-code {
        margin: 0 auto;
        margin-bottom: 10px;
      }
      .download-text {
        color: #000;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        text-align: center;
      }
    }
  }
  .visit-container {
    border-radius: 8px;
    background-color: #fff;
    padding: 26px;

    .btn-visits {
      background-color: #103F5E;
      border-radius: 13px;
      font-size: 16px;
      line-height: 19px;
    }
  }
  .entry-logs {
    border-radius: 8px;
    background-color: #fff;
    padding-left: 26px;
  }
  .pagination {
    margin: 0.5rem auto;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
  }
  /* Labtop L*/
  @media (max-width: 1440px) {
    .dashboard-header {
      .user-card {
        .settings {
          display: flex;
          align-items: flex-start;
          .dropdown {
            // margin-right: 3.5rem;
          }
        }
      }
    }
  }
  /* Labtop */
  @media (max-width: 1024px) {
    .dashboard-header {
      .non-system-user-card {
        .settings {
          width: 75.5%;
          .dropdown {
            margin-right: 6px !important;
          }
          .img {
            margin-right: 30px !important;
          }
        }
        .qr-wrapper {
          width: 23%;
        }
      }
      .details-card {
        .settings,
        .info {
          display: block;
          padding-left: 0;
          .user-name,
          .phone {
            padding-right: 0;
          }
          .company-email-wrapper {
            padding: 0;
            margin-top: 37px;
            &::before {
              height: 0;
            }
          }
        }
      }
      .companies-card {
        height: 674px;
        .header {
          display: block;
          .app-search {
            width: 100% !important;
          }
        }
        .entities-list {
          .entity {
            font-size: 12px !important;
          }
          .actions {
            flex-direction: column;
            justify-content: center;
            .btn {
              width: 58px !important;
              font-size: 12px !important;
            }
            .btn-success {
              margin-bottom: 3px !important;
            }
          }
        }
      }
    }
  }
  /* between */
  @media (min-width: 768px) and (max-width: 940px) {
    .non-system-user-card {
      .settings {
        display: block !important;
        width: 68% !important;
        .dropdown {
          margin-right: 6px !important;
        }
        .img {
          margin-right: 30px !important;
        }
        .user-info {
          .user-name,
          .phone {
            padding-right: 20px !important;
          }
        }
      }
      .qr-wrapper {
        width: 30% !important;
      }
    }
  }
  /* Tablet */
  @media (max-width: 768px) {
    .dashboard-header {
      display: block;
      .non-system-user-card {
        display: block;
        .settings {
          display: block;
          width: 100%;
          .dropdown,
          .img {
            display: inline-block;
            margin-bottom: 15px;
          }
          .dropdown {
            margin-right: 100px !important;
          }
          .user-info {
            width: 100%;
            .user-name,
            .phone {
              padding-right: 15px;
            }
          }
        }
        .qr-wrapper {
          width: 100%;
          flex-direction: column;
          justify-content: center;
          .qr {
            width: 40%;
            padding: 10px;
            margin: 0 auto;
            margin-bottom: 23px;
          }
          .mobile-actions {
            // display: flex;
            flex-direction: column;
            img {
              cursor: pointer;
            }
            .apple-wallet {
              margin-bottom: 20px;
            }
          }
        }
      }
      .details-card {
        width: 100%;
        margin-bottom: 20px;
      }
      .companies-card {
        height: 100%;
        overflow: hidden;
        .header {
          .title-wrapper {
            justify-content: center;
            flex-direction: row-reverse;
            .title {
              font-size: 14px;
              margin-right: 0;
              margin-left: 14px;
            }
            .add-icon {
              font-size: 1.5rem;
            }
          }
        }
        .entities-list {
          .entity-item {
            .entity {
              font-size: 14px;
            }
          }
          .invitation-item {
            padding: 0;
            background-color: transparent;
            .invitation-entity {
              font-size: 14px;
              background: #f7f7f7;
              padding: 20px;
              border-radius: 5px;
              width: 80%;
            }
          }
          .actions {
            display: block !important;
            text-align: center;
            .accept {
              margin-right: 0 !important;
              display: block;
            }
          }
        }
      }
      .user-card {
        .settings {
          display: flex;
          .qr-img-wrapper {
            .img {
              .user-avatar {
                height: 70px;
                width: 70px;
              }
            }
            .qr {
              display: none;
            }
          }
        }
      }
    }
    .qr-mobile-view {
      display: block;
    }
  }
  /* Mobile */
  @media (max-width: 500px) {
    .dashboard-header {
      .non-system-user-card {
        .settings {
          .dropdown {
            margin-right: 45px !important;
          }
          .user-info {
            display: block;
            margin-right: 0;
            .phone {
              margin-bottom: 37px;
            }
            .company-email-wrapper {
              padding-left: 0;
              &::before {
                height: 0;
              }
            }
          }
        }
        .qr-wrapper {
          .qr {
            width: 60%;
          }
        }
      }
    }
    .qr-mobile-view {
      .qr {
        width: 80%;
      }
    }
  }
}
</style>
